module.exports = __webpack_public_path__ + "img/product.aa7db678.svg";